import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="D0TWvbqzMnI"
                    title="IPv6 Portfreigabe bei einer AVM Fritzbox am Beispiel einer INSTAR 2K+ IP Kamera"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IPv6 Portfreigabe bei einer AVM Fritzbox am Beispiel einer INSTAR 2K+ IP Kamera"
              footer={
                <EuiText>
                  <p>Herzlich willkommen zu unserem neuesten Tutorial! In diesem Video zeigen wir euch, wie ihr eine IPv6 Portfreigabe auf eurer AVM Fritzbox 7590 einrichtet, um eure INSTAR 2K+ IP Kamera problemlos von außen erreichbar zu machen.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}